// extracted by mini-css-extract-plugin
module.exports = {"section_hero":"hero_section_hero____qRc","wrapper":"hero_wrapper__LE0ty"};